// new submodule
export default {
	/**
	 * Initalizes listeners for element insertion and form visibility toggles in the comment sections (both plenary and score-types).
	 * Makes sure that every (nested) subtree only gets one set of listeners attached.
	 */
	section: {
		init($targetContainer = $("body")) {
			$targetContainer
				.find("div.PlenaryCommentsSection, div.ScoreCommentsSection")
				.each(function () {
					const $section = $(this);
					if ($section.hasClass("j-initilaized")) {
						return; // 'continue' for jQuery
					}

					pp.log("COMMENT init section -- section", this);
					$section.addClass("j-initilaized");
					// add insert observer for single comments
					$section
						.find(
							".ScoreComment__comments-list:first, .PlenaryComment__comments-list:first",
						)
						.observe()
						.on("insertNode", (event, el) => {
							if (!el.textContent.trim().length) {
								return; // For some reason bootstrap inserts empty text nodes (only in moderator's area)
							}

							// pp.log("COMMENT insert comment in init (top level comment)", event, el);
							pp.comment.section.initSubTree($(el));
							// @ts-expect-error
							$(el).find("textarea").not(".j-autosize-disabled").autosize();

							// remove placeholder if present (only needed for the top comments in consensus games)
							$(".j-comment-placeholder").remove();
						});

					// Trigger now manually once
					pp.comment.section.initSubTree(
						$section.find(
							".ScoreComment__comments-list:first, .PlenaryComment__comments-list:first",
						),
					);

					pp.comment.initFormHandlerListeners(
						$section,
						".ScoreComment__add-fields--first, .PlenaryComment__add-fields",
					);

					$section
						.find("button.ScoreComments__sort-button")
						.off("click")
						.on("click", function () {
							// As one big list
							pp.comment.updateSorting(
								$(this)
									.parents("div.ScoreCommentsSection")
									.find(
										".ScoreComment__comments-list:first, .PlenaryComment__comments-list:first",
									),
							);
						});

					// Init message limiter separately for the first comments form
					pp.comment.limiter.init($(this));

					pp.vue.mountElementsInContainer($section);
				});
		},

		initSubTree($tree) {
			// pp.log("COMMENT init subtree, tree, tree's comment list", $tree, $tree.find('.ScoreComment__comments-list, .PlenaryComment__comments-list'));
			$tree
				.find(".ScoreComment__comments-list, .PlenaryComment__comments-list")
				.observe()
				.on("insertNode", (event, el) => {
					if (el.textContent.trim().length == 0) {
						return; // For some reason bootstrap inserts empty text nodes (only in moderator's area)
					}

					// pp.log("insertNode in subtree:", $tree, event, el, $(el).find('textarea'));
					pp.comment.section.initSubTree($(el));
					// @ts-expect-error
					$(el).find("textarea").not(".j-autosize-disabled").autosize();
					event.stopPropagation(); // don't bubble up
				});

			$tree.find("time[data-time-ago]").timeago();
			pp.comment.limiter.init($tree);
			pp.comment.initFormHandlerListeners(
				$tree,
				".ScoreComment__add-fields, .PlenaryComment__add-fields",
			);

			$tree.find("textarea:visible").autosize();
		},
	},

	/**
	 * Listen to clicks on the 'share your opinion' in the menu bar of the score comments and toggle the comments form
	 */
	initFormHandlerListeners($targetTree, textareaContainerSelector) {
		const $commentForm = $targetTree.find(textareaContainerSelector);
		$commentForm.one("shown.bs.collapse", (event) => {
			$(event.target)
				.find("textarea")
				.not(".j-autosize-disabled")
				// @ts-expect-error
				.autosize()
				.focus();
		});

		/**
		 * Listen to input on the textareas and only enable the send button if there is content
		 */
		$commentForm
			.find("textarea")
			.off("input keyup")
			.on("input keyup", function () {
				// @ts-expect-error
				$(this)
					.closest("form")
					.find("button")
					// @ts-expect-error
					.prop("disabled", $(this).val().length == 0);
			});
		$commentForm.find("textarea").trigger("input"); // Trigger once now
		// Prevent Rails from piping through the event and execute `enableFormElements`, which would re-enable the disabled button
		$commentForm
			.off("ajax:complete")
			.one(
				"ajax:complete",
				pp.viewHelpers.keepSubmitButtonDisabledAfterAjaxFormSubmit,
			);
	},

	paginateSubComments: {
		init() {
			// pp.log("COMMENT into paginateSubComments init");
			$(
				"div.ScoreCommentsSection > .ScoreComment__comments-list > .ScoreComment",
			).each(function () {
				const $this = $(this);
				const $childComments = $this
					.children(".ScoreComment__comments-list")
					.children(".ScoreComment");

				if (
					$childComments.length <= 3 ||
					$this.find(".ScoreComment__comments-list > div.load-more-comments")
						.length
				) {
					return; // 'continue' for jQuery
				}

				$childComments.slice(3).addClass("hidden");
				pp.log(
					"COMMENT child comment length for:",
					$this,
					$childComments.length - 3,
				);
				const showMoreLabel = I18n.t("global.x_more", {
					count: $childComments.length - 3,
				});
				const $loadMoreEl = $(
					`<div class="load-more-comments">${showMoreLabel}</div>`,
				);
				// @ts-expect-error
				$childComments.eq(3).after($loadMoreEl.get(0));

				$this
					.find("div.load-more-comments")
					.on("click", pp.comment.paginateSubComments.unhideMoreComments);
			});
		},

		unhideMoreComments() {
			// pp.log("COMMENT unhideMoreComments", this, $(this).parent().html());
			$(this).parent().children(".ScoreComment").removeClass("hidden");
			$(this).remove();
		},
	},

	// customOldScore will only work if the commentScoreHash only contains one key-value pair
	updateScores(commentScoreHash, customOldScore) {
		// pp.log("COMMENT updateCommentScores", commentScoreHash, customOldScore);
		for (const key in commentScoreHash) {
			// pp.log(key, commentScoreHash[key]);
			const $commentContainer = $(
				`.ScoreComment[data-for-comment-id=${key}], .PlenaryComment[data-for-comment-id=${key}]`,
			);
			const $scoreSpan = $commentContainer
				.find(`.j-ratings[data-for-comment-id=${key}]`)
				.find("span.j-comment-score");

			if ($scoreSpan.length == 0) {
				return; // no need to do anything
			}

			let oldScore =
				customOldScore === undefined
					? parseInt($scoreSpan.html())
					: customOldScore;
			let scoreDiff = commentScoreHash[key] - oldScore;
			if (scoreDiff == 0) {
				return;
			}

			$commentContainer.attr("data-score", commentScoreHash[key]);
			// pp.log("COMMENT updateCommentScores in span: ", $commentContainer, $scoreSpan, oldScore, commentScoreHash[key], scoreDiff);
			$scoreSpan.html(commentScoreHash[key]);

			$scoreSpan
				.siblings(".ScoreComment__ratings__change-overlay")
				.html(`${scoreDiff > 0 ? "+" : ""}${scoreDiff.toString()}`)
				.addClass(
					`ScoreComment__ratings__change-overlay--${scoreDiff > 0 ? "green" : "red"}`,
				)
				.show()
				.fadeOut(5000);

			// Only for the moderators score comment accordion
			$("a[data-for-comment-id='" + key + "']")
				.find("span.j-comment-score")
				.html(commentScoreHash[key]);

			$commentContainer
				.parents("div.ScoreCommentsSection")
				.find("button.ScoreComments__sort-button")
				.prop("disabled", false);
		}
	},

	/**
	 * rearrange the score comment DOM elements both in the menu and the currently displayed thread
	 */
	updateSorting($targets) {
		pp.log("COMMENT sorting score contributions - targets:", $targets);
		const $container = $targets.first().parents("div.ScoreCommentsSection");
		if ($container.find("button.ScoreComments__sort-button").prop("disabled")) {
			// Don't do anything if the button is disabled
			return;
		}

		// pp.log("sort targets", $targets);
		// Get the Comments menu and the top Comment list in the currently shown comment thread
		$targets.each(function () {
			// @ts-expect-error
			const $container = $(this);
			// pp.log("COMMENT sorting, looking at container", $container, $container.children('.ScoreComment'));
			// @ts-expect-error
			const $sortedEls = $container.children(".ScoreComment").sort((a, b) => {
				// There is also the div.load-more-comments, exclude that one
				// console.log("EL a", $(a).data('score'), $(a).attr('data-score'), $(a).data().score);
				// console.log("EL b", $(b).data('score'), $(b).attr('data-score'), $(b).data().score);
				// @ts-expect-error
				const sa = parseInt($(a).attr("data-score"), 10);
				// @ts-expect-error
				const sb = parseInt($(b).attr("data-score"), 10);

				if (sa < sb) {
					return -1;
				} else if (sa > sb) {
					return 1;
				} else {
					// This mirrors the `default_scope -> { order(score: :desc, created_at: :desc) }` in comment.rb:
					// a Comment with a higher id will also have a higher `created_at` value, so the newer Comments will come first
					// @ts-expect-error
					const ida = parseInt($(a).attr("data-for-comment-id"), 10);
					// @ts-expect-error
					const idb = parseInt($(b).attr("data-for-comment-id"), 10);
					return ida < idb ? -1 : 1;
				}
			});

			$sortedEls.each(function () {
				// @ts-expect-error
				$container.prepend(this);
			});

			$container.children(".ScoreComment").each((index, childComment) => {
				// Sort sub-comment threads recursively
				if (
					$(childComment).find(".ScoreComment__comments-list .ScoreComment")
						.length
				) {
					// pp.log("recur", $(childComment), $(childComment).find('.ScoreComment__comments-list'));
					pp.comment.updateSorting(
						$(childComment).find(".ScoreComment__comments-list"),
					);
				}
			});
		});

		// Disable button, let recursion run first
		setTimeout(() => {
			$container
				.find("button.ScoreComments__sort-button")
				.prop("disabled", true);
		}, 50);
	},

	/**
	 * Increments all (there might be several if the score comment menu is visible) spans that display a commentable's Comments count
	 */
	incrementCount($commentable) {
		// pp.log("COMMENT incrementCommentsCount", $commentable);
		// For the full score view or the plenary Comments
		const $commentsCountSpan = $commentable
			.children("div.j-ratings, div.ScoreComment__options")
			.find("span.j-comments-count");
		const newCount = parseInt($commentsCountSpan.html(), 10) + 1;
		const commentModelName = I18n.t("activerecord.models.comment", {
			count: newCount,
		});
		$commentsCountSpan
			.html(`${newCount} ${commentModelName}`)
			.parent()
			.removeClass("disabled");
	},

	/**
	 * Force a 15s gap between sending two comments
	 */
	limiter: {
		delay: 15000,

		init($tree) {
			// pp.log("COMMENT init msg limiter for tree", $tree);
			if (pp.comment.limiter.interval !== undefined) {
				// pp.log("interval exists");
				pp.comment.limiter.lockForms($tree);
			}
			$tree
				.find(
					".PlenaryComment__add-fields > form, .ScoreComment__add-fields > form",
				)
				.off("submit")
				.on("submit", ({ target }) => {
					// Wait until the confirm for the last sent message has arrived
					$(target).one("ajax:success", (event) => {
						setTimeout(pp.comment.limiter.lockForms, 5);
					});
				});
		},

		lockForms($tree) {
			// pp.log("COMMENT into lockForms for tree", $tree);
			if ($tree === undefined) {
				$tree = $("body");
			}
			$tree
				.find(
					".PlenaryComment__add-fields > form, .ScoreComment__add-fields > form",
				)
				.children("textarea")
				.prop("disabled", true)
				.val(I18n.t("plenary.wait_for_next_message"));
			$tree
				.find(
					".PlenaryComment__add-fields > form, .ScoreComment__add-fields > form",
				)
				.children("button")
				.prop("disabled", true);

			if (
				pp.comment.limiter.startTime === undefined ||
				pp.comment.limiter.startTime <
					new Date(new Date().getTime() - pp.comment.limiter.delay)
			) {
				pp.comment.limiter.startTime = Date.now();
				pp.comment.limiter.setInterval();
			}
		},

		setInterval() {
			pp.comment.limiter.interval = setInterval(() => {
				const percent =
					100 -
					((Date.now() - pp.comment.limiter.startTime) /
						pp.comment.limiter.delay) *
						100;
				$(
					".PlenaryComment__add-fields > form, .ScoreComment__add-fields > form",
				)
					.find(".ScoreComment__cooldown-bar")
					.css("width", `${percent}%`);

				if (percent <= 0) {
					clearInterval(pp.comment.limiter.interval);
					pp.comment.limiter.interval = undefined;
					// Don't enable the button again, it would be disabled immediately because the corresponding textarea will be empty
					$(
						".PlenaryComment__add-fields > form, .ScoreComment__add-fields > form",
					)
						.children("textarea")
						.prop("disabled", false)
						.val("");
				}
			}, 50);
		},
	},
};
